import Tooltip from '@/components/Tooltip'
import { Add16Regular } from '@/components/Icon'
import styles from './AddWorkspaceTile.module.scss'

export default function AddWorkspaceTile({ onClick }) {
  return (
    <Tooltip text="Create new workspace" placement="right">
      <button
        type="button"
        className={styles.tile}
        aria-label="Create new workspace"
        onClick={onClick}
      >
        <Add16Regular className={styles.icon} aria-hidden />
      </button>
    </Tooltip>
  )
}
